import { inviteConstants as ic } from './constants'
import { userService, eventService, generalService, workplaceService } from 'srcReact/services'
import { isEmpty } from 'srcReact/helpers/validator'

export const inviteActions = {
  sendInvitesToNonWPMembers,
  inviteToWorkplace
}

function sendInvitesToNonWPMembers(entityId, entityType, emails, message, callbackSuccess) {
  return (dispatch) => {
    dispatch(request({ entityId, entityType, emails, message }))

    workplaceService.sendInviteToNonWPMembers(entityId, entityType, emails, message).then(
      (response) => {
        dispatch(success(response))
        if (typeof callbackSuccess === 'function') {
          callbackSuccess()
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.INVITE_NON_WP_MEMBERS_REQUEST, response }
  }
  function success(response) {
    return { type: ic.INVITE_NON_WP_MEMBERS_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.INVITE_NON_WP_MEMBERS_SUCCESS, error }
  }
}

function inviteToWorkplace(workplace_id, emails, message, callbackSuccess, callbackFailure) {
  return (dispatch) => {
    dispatch(request({ workplace_id, emails, message }))

    workplaceService.inviteToWorkplace({ workplace_id, emails, message }).then(
      (response) => {
        dispatch(success(response))
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(response)
        }
      },
      (error) => {
        dispatch(failure(error))
        if (typeof callbackFailure === 'function') {
          callbackFailure(error)
        }
      }
    )
  }

  function request(data) {
    return { type: ic.INVITE_TO_WORKPLACE_REQUEST, data }
  }
  function success(data) {
    return { type: ic.INVITE_TO_WORKPLACE_SUCCESS, data }
  }
  function failure(error) {
    return { type: ic.INVITE_TO_WORKPLACE_FAILURE, error }
  }
}
